import { call, takeLatest } from 'redux-saga/effects';
import * as constants from './reports.constants';
import * as types from './reports.types';
import { fetchMeetingReports, fetchUserReports } from './reports.saga-services';

function* invokeFetchMeetingReports(action: types.IFetchMeetingReportsAction) {
  yield call(fetchMeetingReports, action.payload.meetingId, action.payload.queryParams);
}

function* invokeFetchUserReports(action: types.IFetchUserReportsAction) {
  yield call(fetchUserReports, action.payload.userId, action.payload.queryParams);
}

export function* watchMeetingReportsPageSaga() {
  yield takeLatest(constants.FETCH_MEETING_REPORTS, invokeFetchMeetingReports);
  yield takeLatest(constants.FETCH_USER_REPORTS, invokeFetchUserReports);
}
